/* tslint:disable:max-line-length */
import {Component, OnInit, Input, ViewChild, ElementRef, AfterViewInit} from '@angular/core';
import {User} from '../../data-objects/user';
import {RefDataItem, RefDataType} from '../../data-objects/ref-data-item';
import {FormControl, Validators} from '@angular/forms';
import {LoginService} from '../../services/login.service';
import {RefDataDropdownComponent} from '../ref-data-dropdown/ref-data-dropdown.component';
import {RefDataService} from '../../services/ref-data.service';

const numberRE = /^[0-9]*$/;
const emailRE = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/;

@Component({
  selector: 'app-owner-details',
  templateUrl: './owner-details.component.html',
  styleUrls: ['./owner-details.component.css']
})
export class OwnerDetailsComponent implements OnInit, AfterViewInit {
  @ViewChild('focusInput') focusInputElement: ElementRef;
  @Input()
  isLandlineMandatory: boolean;
  @Input()
  isMobileMandatory: boolean;
  @Input()
  isEmailMandatory = true;
  @Input()
  public phoneMailLabel: 'Phone';
  @Input()
  applicantDetails: User;
  @Input()
  isReadOnly: boolean;

  @ViewChild('title') titles: RefDataDropdownComponent;

  emailControl: FormControl;
  phoneNumberControl: FormControl;
  mobileNumberControl: FormControl;
  postalAddressControl: FormControl;

  emailControlLength = 50;

  phoneNumberControlMaxLength = 10;
  mobileNumberControlMaxLength = 10;

  phoneNumberControlMinLength = 8;
  mobileNumberControlMinLength = 10;

  firstNameControlLength = 50;
  lastNameControlLength = 50;

  postalAddressControlLength = 200;

  firstNameControl: FormControl;
  lastNameControl: FormControl;

  constructor(private loginService: LoginService
    , private refDataService: RefDataService) {
    this.firstNameControl = new FormControl('', [Validators.compose([
      Validators.required,
      Validators.maxLength(this.firstNameControlLength)
    ])]);
    this.lastNameControl = new FormControl('', [Validators.compose([
      Validators.required,
      Validators.maxLength(this.lastNameControlLength)
    ])]);
    this.postalAddressControl = new FormControl('', [Validators.compose([
      Validators.required,
      Validators.maxLength(this.postalAddressControlLength)
    ])]);
    this.emailControl = new FormControl('', [Validators.compose([
      Validators.maxLength(this.emailControlLength),
      Validators.pattern(emailRE)])
    ]);
    this.phoneNumberControl = new FormControl('', [Validators.compose([
      Validators.maxLength(this.phoneNumberControlMaxLength),
      Validators.minLength(this.phoneNumberControlMinLength),
      Validators.pattern(numberRE)
    ])]);

    this.mobileNumberControl = new FormControl('', [Validators.compose([
      Validators.maxLength(this.mobileNumberControlMaxLength),
      Validators.minLength(this.mobileNumberControlMinLength),
      Validators.pattern(numberRE)
    ])]);
  }

  ngAfterViewInit(): void {
    this.setFocusOnFirstElement();
  }

  setFocusOnFirstElement(): void {
    this.focusInputElement.nativeElement.focus();
  }

  ngOnInit() {
    if (this.isLandlineMandatory) {
      const existingValidators = this.phoneNumberControl.validator;
      this.phoneNumberControl.setValidators(Validators.compose([existingValidators, Validators.required]));
    }
    if (this.isMobileMandatory) {
      const existingValidators = this.mobileNumberControl.validator;
      this.mobileNumberControl.setValidators(Validators.compose([existingValidators, Validators.required]));
    }

    if (this.isEmailMandatory) {
      const existingValidators = this.emailControl.validator;
      this.emailControl.setValidators(Validators.compose([existingValidators, Validators.required]));
    }

    const pleaseSelect: RefDataItem[] = [new RefDataItem(0, 'Please Select...')];
    this.refDataService.retrieveReferenceData(RefDataType.Titles, '').subscribe(
      (refDataItems) => {
        if (this.titles) {
          this.titles.items = pleaseSelect.concat(refDataItems);
          if (this.applicantDetails) {
            for (let i = 0; i < this.titles.items.length; i++) {
              if (this.applicantDetails.title === this.titles.items[i].display) {
                this.titles.selectedItemId = this.titles.items[i].id;
                break;
              }
            }
          }
        }
      },
      err => {
      });
  }

  get invalid(): boolean {
    return this.emailControl.invalid || this.phoneNumberControl.invalid || this.mobileNumberControl.invalid ||
      this.firstNameControl.invalid || this.lastNameControl.invalid 
      //|| (this.isGuestUserLoggedIn() && (!this.titles.selectedItemId || this.titles.selectedItemId === '0')) 
      ;
  }

  public handleTitleChanged($event) {
    const selectedItem: RefDataItem = this.titles.selectedItem;
    if (selectedItem) {
      this.applicantDetails.title = selectedItem.display;
      this.applicantDetails.titleSelected = selectedItem.display !== 'Please Select...';
    }
  }

  get titleSelected(): boolean {
    return this.applicantDetails.titleSelected;
  }

  get readOnlyTitle(): string {
    return this.applicantDetails.title;
  }

  isGuestUserLoggedIn(): boolean {
    return this.loginService.isGuestUserLoggedIn();
  }

  displayErrorMessage(): string {
    this.emailControl.markAsTouched();
    this.phoneNumberControl.markAsTouched();
    this.mobileNumberControl.markAsTouched();
    this.firstNameControl.markAsTouched();
    this.lastNameControl.markAsTouched();
    this.postalAddressControl.markAsTouched();

    let errorText = '';

   // if ((this.isGuestUserLoggedIn() && (!this.titles.selectedItem || this.titles.selectedItem.display === 'Please Select...'))) {
   //   errorText += 'Please select Owner\'s Title' + '<br>';
   // }

    if (this.firstNameControl.invalid) {
      if (this.firstNameControl.hasError('maxlength')) {
        errorText += 'Owner\'s First Name cannot exceed ' +
          this.firstNameControlLength + ' characters' + '<br>';
      }

      if (this.firstNameControl.hasError('required')) {
        errorText += 'Please enter Owner\'s First Name' + '<br>';
      }
    }

    if (this.lastNameControl.invalid) {
      if (this.lastNameControl.hasError('maxlength')) {
        errorText += 'Owner\'s Last Name cannot exceed ' +
          this.firstNameControlLength + ' characters' + '<br>';
      }

      if (this.lastNameControl.hasError('required')) {
        errorText += 'Please enter Owner\'s Last Name' + '<br>';
      }
    }

    if (this.phoneNumberControl.invalid) {
      if (this.phoneNumberControl.hasError('maxlength')) {
        errorText += 'Owner\'s Phone Number cannot exceed ' +
          this.phoneNumberControlMaxLength + ' characters' + '<br>';
      }

      if (this.phoneNumberControl.hasError('required')) {
        errorText += 'Please enter Owner\'s Phone Number' + '<br>';
      }

      if (this.phoneNumberControl.hasError('pattern')) {
        errorText += 'Please enter numbers only in Owner\'s phone number' + '<br>';
      }
    }

    if (this.mobileNumberControl.invalid) {
      if (this.mobileNumberControl.hasError('maxlength')) {
        errorText += 'Owner\'s Mobile Number should be ' +
          this.mobileNumberControlMaxLength + ' characters' + '<br>';
      }

      if (this.mobileNumberControl.hasError('minlength')) {
        errorText += 'Owner\'s Mobile Number should be  ' +
          this.mobileNumberControlMinLength + ' characters' + '<br>';
      }

      if (this.mobileNumberControl.hasError('required')) {
        errorText += 'Please enter Owner\'s Mobile Number' + '<br>';
      }

      if (this.mobileNumberControl.hasError('pattern')) {
        errorText += 'Please enter numbers only in Owner\'s Mobile number' + '<br>';
      }
    }

    if (this.emailControl.invalid) {
      if (this.emailControl.hasError('maxlength')) {
        errorText += 'Owner\'s Email cannot exceed ' + this.emailControlLength + ' characters' + '<br>';
      }
      if (this.emailControl.hasError('pattern')) {
        errorText += 'Please enter a valid Owner\'s Email' + '<br>';
      }
      if (this.emailControl.hasError('required')) {
        errorText += 'Please enter Owner\'s Email' + '<br>';
      }
    }

    this.markValidationControlsAsUntouched();

    return errorText;
  }

  clearTitle() {
    if (this.titles) {
      this.titles.selectedItemId = 0;
    }
  }

  get getCssClass(): string {
    return 'form-control';
  }

  markValidationControlsAsUntouched() {
    this.emailControl.markAsUntouched();
    this.phoneNumberControl.markAsUntouched();
    this.mobileNumberControl.markAsUntouched();
    this.firstNameControl.markAsUntouched();
    this.lastNameControl.markAsUntouched();
    this.postalAddressControl.markAsUntouched();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/owner-details/owner-details.component.ts